import type { AtomModel } from '@models/atom.model';

import type { TableEditorTextColumnData } from '@stratumn/studio-shared';

type Props = {
  atom: AtomModel<TableEditorTextColumnData>;
};

export const TextSettingsModal = ({ atom }: Props) => {
  atom;
  return <></>;
};
